// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
require('whatwg-fetch');
module.exports = self.fetch;



/*****************
 ** WEBPACK FOOTER
 ** ./~/marty/~/isomorphic-fetch/npm-client.js
 ** module id = 487
 ** module chunks = 0
 **/